import { render } from "./tags.vue?vue&type=template&id=310cdca6&scoped=true"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"

import "./tags.vue?vue&type=style&index=0&id=310cdca6&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./tags.vue?vue&type=style&index=1&id=310cdca6&rel=stylesheet%2Fscss&lang=scss"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310cdca6"]])

export default __exports__